import Dialog from "@material-ui/core/Dialog";
import { useAppDispatch, useAppSelector } from "app/store";
import {
  closeTrackingDialog,
  selectStateTrackingDialog,
} from "app/store/trackingApp/trackingDialogSlice";
import React from "react";

const TrackingDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const { open, options } = useAppSelector(selectStateTrackingDialog);

  return (
    <Dialog
      open={open}
      onClose={() => dispatch(closeTrackingDialog())}
      aria-labelledby="tracking-dialog-title"
      aria-describedby="tracking-dialog-description"
      {...options}
    />
  );
};

export default TrackingDialog;
